import React, { useEffect, useState } from "react";
import {
  FiBell,
  FiArrowDown,
  FiCreditCard,
  FiCalendar,
  FiArrowRight,
} from "react-icons/fi";
import RequestsSection from "./RequestsSection";
import { motion } from "framer-motion";
import { useNavigate } from "react-router-dom";
import {
  getDocById,
  getAllDocsSnap,
  queryAllDocsByFieldSnap,
  getAllPendingRequests,
} from "../../../utils/firebase/Firebase.utils";
import { useSelector } from "react-redux";
import QuickContactsSection from "../Contacts/QuickContactsSection";
import AdvisoryComponent from "./AdvisoryComponent";
import Announcements from "../Announcements/Announcements";
import ErrorNoticePage from "./ErrorNoticePage";
import { FiX } from "react-icons/fi";
import { appName } from "../../../utils/constants";
function UserDashboard() {
  const navigate = useNavigate();
  const [identifiers, setIdentifiers] = React.useState([]);
  const [outstandingBills, setOutstandingBills] = React.useState([]);
  const [isLoading, setIsLoading] = React.useState(true);
  const [activeRequests, setActiveRequests] = React.useState([]);
  const [notifications, setNotifications] = React.useState([]);
  const [unreadNotifications, setUnreadNotifications] = React.useState([]);
  const [closeAnnouncement, setCloseAnnouncment] = useState(false);

  const currentUser = useSelector((state) => state.userObject);

  useEffect(() => {
    const unsubscribeNotifications = getAllDocsSnap("notifications", (data) => {
      const userNotifications = data.filter(
        (notification) => notification.to === currentUser.email
      );
      setNotifications(userNotifications);

      const unreadNotifications = userNotifications.filter(
        (notification) => notification.read === false
      );
      setUnreadNotifications(unreadNotifications);
      // if (unreadNotifications.length > 0) {
      //   toast.success(
      //     `You have ${unreadNotifications.length} unread notifications`
      //   );
      // }
    });

    // Cleanup function to unsubscribe
    return () => unsubscribeNotifications();
  }, [currentUser.email]); // Adding currentUser.email as a dependency

  useEffect(() => {
    const fetchActiveRequests = async () => {
      const pendingRequests = await getAllPendingRequests(currentUser.email);
      setActiveRequests(pendingRequests);
    };

    fetchActiveRequests();
  }, [currentUser.email]); // Adding currentUser.email as a dependency

  useEffect(() => {
    const fetchUserData = async () => {
      const user = await getDocById("users", currentUser.uid);
      setIdentifiers(user.linkedIdentifiers);
    };
    fetchUserData();
  }, [currentUser.uid]); // Adding currentUser.uid as a dependency

  useEffect(() => {
    const fetchOutstandingBills = async () => {
      const allBills = [];
      for (const identifier of identifiers) {
        const data = await queryAllDocsByFieldSnap(
          "billings",
          "identifier",
          "==",
          identifier,
          (data) => {
            const unpaidBills = data.filter((bill) => bill.status !== "paid");

            allBills.push(...unpaidBills);
            setOutstandingBills(allBills);
            setIsLoading(false);
          }
        );
      }
    };

    if (identifiers?.length) {
      fetchOutstandingBills();
    }
  }, [identifiers]);

  //total all bills
  const totalBills = outstandingBills.reduce((acc, bill) => {
    if (!bill) {
      return acc;
    }
    return acc + parseFloat(bill.amount?.replace(/,/g, ""));
  }, 0);

  const dateConverter = (timestamp) => {
    const date = new Date(timestamp);
    return date;
  };

  if (!identifiers) {
    return <ErrorNoticePage />;
  }

  const handleCloseAnnouncement = () => {
    setCloseAnnouncment(true);
  };

  return (
    <motion.div className="flex flex-col items-start justify-center p-3 relative max-w-[450px] m-auto w-screen bg-gray-50">
      {/* header section */}
      <div className="w-full bg-white shadow-sm rounded-lg flex items-center justify-between py-3 px-4 mb-3">
        <div className="flex items-center space-x-2">
          <div className="text-[#363062] uppercase font-bold text-xs">
            {appName}
          </div>
          <div className="text-gray-400 text-xs">|</div>
          <div className="text-gray-500 text-xs">Powered by</div>
          <img
            src="https://www.elegho.com/_next/image?url=https%3A%2F%2Fres.cloudinary.com%2Fduk7mmsc6%2Fimage%2Fupload%2Fv1741437371%2FElegho%2FElegho-Logo_qdoodo.png&w=640&q=75"
            alt="Elegho"
            className="h-4"
          />
        </div>
        <div
          className="flex items-center relative cursor-pointer"
          onClick={() => navigate("/notifications")}
        >
          {unreadNotifications.length > 0 && (
            <div className="absolute -top-1 -right-1 bg-[#8FCD00] text-[#363062] text-xs font-bold rounded-full h-4 w-4 flex items-center justify-center">
              {unreadNotifications.length}
            </div>
          )}
          <FiBell className="text-lg text-[#363062]" />
        </div>
      </div>

      {/* outstanding bill section */}
      <div
        className="relative bg-gradient-to-r from-[#363062] to-[#4D4C7D] w-full text-white rounded-lg p-4 shadow-md mb-3 overflow-hidden"
        onClick={() => navigate("/bills")}
      >
        <div className="absolute top-0 right-0 w-32 h-32 bg-[#8FCD00] opacity-10 rounded-full -mr-10 -mt-10"></div>
        <div className="absolute bottom-0 left-0 w-24 h-24 bg-[#8FCD00] opacity-10 rounded-full -ml-10 -mb-10"></div>
        <div className="flex items-center justify-between mb-3">
          <div className="flex items-center">
            <FiCreditCard className="mr-2 text-[#8FCD00]" />
            <span className="text-sm font-medium">Outstanding Balance</span>
          </div>
          <button
            className="flex items-center text-xs font-medium text-[#8FCD00] hover:text-white transition-all"
            onClick={() => navigate("/bills")}
          >
            View Details
            <FiArrowRight className="ml-1" />
          </button>
        </div>

        <div className="flex justify-between items-center">
          <div className="text-left">
            <div className="flex items-baseline">
              <span className="text-xs mr-1 text-gray-300">PHP</span>
              {isLoading ? (
                <span className="italic text-gray-300">Loading...</span>
              ) : (
                <span className="text-4xl font-bold text-white">
                  {totalBills.toLocaleString(undefined, {
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2,
                  })}
                </span>
              )}
            </div>
            <div className="text-xs text-gray-300 mt-1">
              Association Dues and Water
            </div>
          </div>

          <button
            className="px-4 py-2 bg-[#8FCD00] text-[#363062] rounded-md text-xs font-bold shadow-sm hover:bg-opacity-90 transition-all"
            onClick={() => navigate("/bills")}
          >
            Pay Now
          </button>
        </div>
      </div>

      {/* requests and tasks */}
      <div className="flex items-center justify-center gap-4 w-full">
        <div
          className="rounded-xl bg-eleghoBlue text-white mt-2 flex items-center justify-center overflow-hidden h-12 border border-blue-900 cursor-pointer"
          onClick={() => navigate("/requests")}
        >
          <div className="flex items-center justify-center h-full">
            <div className="font-bold text-eleghoGreen text-4xl p-2">
              {activeRequests.length}
            </div>
            <div className="text-xs uppercase w-16 h-full py-2">
              Active Requests
            </div>
          </div>
          <div className="bg-white text-blue-900 h-full p-2 text-xs flex flex-col items-center justify-center">
            <div>View All</div>
            <div>
              <FiArrowDown />
            </div>
          </div>
        </div>

        <div
          className="rounded-xl bg-eleghoBlue text-white mt-2 flex items-center justify-center overflow-hidden h-12 border border-blue-900 cursor-pointer"
          onClick={() => navigate("/tasks")}
        >
          <div className="flex items-center justify-center h-full">
            <div className="font-bold text-eleghoGreen text-4xl p-2">0</div>
            <div className="text-xs uppercase w-16 h-full py-2">
              Pending Tasks
            </div>
          </div>
          <div className="bg-white text-blue-900 h-full p-2 text-xs flex flex-col items-center justify-center">
            <div>View All</div>
            <div>
              <FiArrowDown />
            </div>
          </div>
        </div>
      </div>

      {/* icons for condo services */}
      <div className="w-full mb-3">
        <RequestsSection />
      </div>

      {/* icons for quick contacts */}
      <div className="w-full mb-3">
        <QuickContactsSection />
      </div>

      {/* advisory section */}
      <div className="mb-3">
        <AdvisoryComponent />
      </div>

      {!closeAnnouncement && (
        <div className="w-full mb-3 bg-gray-200 rounded-lg shadow-sm p-2">
          <div className="flex items-center justify-end">
            <button
              className="text-gray-400 hover:text-[#363062] transition-all"
              onClick={handleCloseAnnouncement}
            >
              <FiX size={18} />
            </button>
          </div>
          <Announcements />
        </div>
      )}
    </motion.div>
  );
}

export default UserDashboard;
